import { BestSeller } from 'components/main-page/home-page/best-seller/BestSeller'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { BEST_SELLER_VALIDATION } from 'services/validation/home-page/bestSellerValidation'
import { constructOptionMultipleSelect, convertErrorMessage, getValueFromArray, uploadFileToS3 } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_BEST_SELLER } from 'services/api-home-page/apiBestSeller'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    best_seller: {
        desktop_background_url: null,
        mobile_background_url: null,
        title: null,
        product_ids: [],
    },
}

const FIELD_NAME_DETAIL = {
    desktop_background_url: 'Background desktop',
    mobile_background_url: 'Background mobile',
    title: 'Title',
    product_ids: 'Product list',
}

export const BestSellerContainer = () => {
    const [reload, setReload] = useState(false)
    const [bestSellerDetail, setBestSellerDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [optionsProduct, setOptionsProduct] = useState([])
    const { fetching: getBestSellerDetail, isLoading } = useFetch(API_BEST_SELLER.DETAIL)
    const { fetching: getUrlImageBackground } = useFetch(API_BEST_SELLER.URL_IMAGE_BACKGROUND)
    const { fetching: getProductList } = useFetch(API_BEST_SELLER.PRODUCT_LIST)
    const { fetching: updateBestSeller, isLoading: isUpdating } = useFetch(API_BEST_SELLER.UPDATE)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm } = useValidation({
        form: bestSellerDetail?.best_seller,
        schema: BEST_SELLER_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        let newData
        if (checked === undefined) {
            newData = { best_seller: { ...bestSellerDetail?.best_seller, [name]: value } }
        } else {
            newData = { [name]: checked }
        }
        setBestSellerDetail({ ...bestSellerDetail, ...newData })
    }

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newOption = constructOptionMultipleSelect(response?.data, 'name', 'id')
            setOptionsProduct(newOption)
        })
    }

    const setUploadBackgroundImage = async (filesName, uploadDetail) => {
        const newBestSellerDetail = { ...bestSellerDetail?.best_seller }

        try {
            const s3Urls = await getUrlImageBackground({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newBestSellerDetail[uploadDetail[i]?.key] = `${item?.url}${item?.fields?.key}`
            })
            await Promise.all(apiS3list)
            const newDetail = {
                ...bestSellerDetail,
                best_seller: newBestSellerDetail,
            }
            onSave(newDetail)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(async () => {
            const backgroundImages = [
                bestSellerDetail?.best_seller?.desktop_background_url,
                bestSellerDetail?.best_seller?.mobile_background_url,
            ]
            const uploadDetail = []
            const filesName = []

            backgroundImages.map((item, index) => {
                if (item?.name) {
                    filesName.push(item?.name?.replace(/\s/g, ''))
                    uploadDetail.push({
                        file: item?.file,
                        key: index === 0 ? 'desktop_background_url' : 'mobile_background_url',
                    })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadBackgroundImage(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...bestSellerDetail }) => {
        const newPayload = {
            ...payload,
            best_seller: {
                ...payload?.best_seller,
                product_ids: getValueFromArray(payload?.best_seller?.product_ids, 'value'),
            },
        }
        updateBestSeller(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Best Seller Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getBestSellerDetail().then((response) => {
            const data = { ...response?.data }
            const { products, ...bestSellerRest } = data?.best_seller
            const newDetail = {
                ...data,
                best_seller: {
                    ...bestSellerRest,
                    product_ids: constructOptionMultipleSelect(products, 'name', 'id'),
                },
            }
            setBestSellerDetail(newDetail)
        })
    }, [reload])

    const props = {
        bestSellerDetail,
        optionsProduct,
        errorForm: { best_seller: { ...errorForm, ...errorMessage } },
        onChangeForm,
        onSearchProduct,
        isLoading,
        isUpdating,
        isLoadingUpload,
        onSubmit,
    }

    return <BestSeller {...props} />
}
